import React, { Fragment, useEffect, useState } from "react";
import { IonModal, IonCard, IonIcon, IonRow } from "@ionic/react";
import "./MessageHistory.scss";
import _ from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";
import { utilService } from "../../../../services/utilService";
import { MessageHistoryService } from "./MessageHistory.service";
import {
  arrowRedoCircleOutline,
  chevronDownCircle,
  chevronUpCircle,
  close,
} from "ionicons/icons";
import Loader from "../../Loader/Loader";
import MediaListCard from "../../../../pages/FileShare/components/MediaListCard/MediaListCard";
import NoResults from "../../NoResults/NoResultsComponent";

interface MessageHistoryParams {
  messageInfoData: any;
  isShowMessageModal: boolean;
  onCancel: () => void;
  updateForwardMessage?: any;
}

const MessageHistory: React.FC<MessageHistoryParams> = (props) => {
  const [smsHistoryData, setSmsHistoryData]: any = useState([]);
  const [isApiCalling, setIsApiCalling] = useState(false);
  const [isSmallScreen, setIsSmallScreen]: any = useState(false);
  const [pageNo, setPageNo]: [number, Function] = useState(1);
  const [smsHistoryNextValue, setSmsHistoryNextValue]: any = useState("");

  useEffect(() => {
    checkIfSmallScreen();
  }, []);

  useEffect(() => {
    if (props.isShowMessageModal) {
      // getMessageHistoryDetails();
    }
  }, [props.isShowMessageModal]);

  useEffect(() => {
    if (!props.isShowMessageModal) {
      setSmsHistoryData(_.cloneDeep([]));
      setSmsHistoryNextValue("");
      setPageNo(1);
    }
  }, [props.isShowMessageModal]);

  const checkIfSmallScreen = () => {
    if (utilService.getScreenSize() === "small") {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  };

  const onScroll = () => {
    if (!_.isEmpty(smsHistoryNextValue)) {
      setPageNo(pageNo + 1);
      // getMessageHistoryDetails(pageNo + 1);
    }
  };

  // const getMessageHistoryDetails = async (page: number = 1) => {
  //   if (page === 1) {
  //     setIsApiCalling(true);
  //   }
  //   const params: any = getSmsHistoryParams(page);
  //   const respSmsHistoryResult: any =
  //     await MessageHistoryService.getMessageHistoryDetails(params);
  //   if (respSmsHistoryResult.isSuccess && respSmsHistoryResult.result?.[0]) {
  //     setSmsHistoryNextValue(respSmsHistoryResult.result?.[0]?.next);
  //     if (page === 1) {
  //       setSmsHistoryData(_.cloneDeep(respSmsHistoryResult.result?.[0]?.data));
  //     } else {
  //       setSmsHistoryData([
  //         ...smsHistoryData,
  //         ...respSmsHistoryResult.result?.[0]?.data,
  //       ]);
  //     }
  //   } else {
     
  //   }
  //   setIsApiCalling(false);
  // };

  const getSmsHistoryParams = (page: number) => {
    var params = {
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      sms_thread_id: props.messageInfoData.sms_thread_id,
      page: page,
    };
    return params;
  };

  const handleMoreButtonClick = (index: any) => {
    const toUserName = document.getElementById(`to-user-details-${index}`);
    toUserName?.style.setProperty("display", "unset");
    const lessButton = document.getElementById(`less-button-${index}`);
    lessButton?.style.setProperty("display", "unset");
    const moreButton = document.getElementById(`more-button-${index}`);
    moreButton?.style.setProperty("display", "none");
  };

  const handleLessButtonClick = (index: any) => {
    const toUserName = document.getElementById(`to-user-details-${index}`);
    toUserName?.style.setProperty("display", "none");
    const lessButton = document.getElementById(`less-button-${index}`);
    lessButton?.style.setProperty("display", "none");
    const moreButton = document.getElementById(`more-button-${index}`);
    moreButton?.style.setProperty("display", "unset");
  };
           
  return (
    <div>
      <IonModal
        isOpen={props.isShowMessageModal}
        backdropDismiss={false}
        className="message-history-modal"
      >
        <div
          className={`close-modal-icon ${
            isSmallScreen && "close-modal-icon-small-screen"
          }`}
          onClick={() => {
            props.onCancel();
          }}
        >
          <IonIcon icon={close} />
        </div>
        {!isApiCalling ? (
          <InfiniteScroll
            dataLength={smsHistoryData.length}
            height={480}
            className="display-sms-container"
            next={() => onScroll()}
            hasMore={true}
            loader={<div></div>}
          >
            {!_.isEmpty(smsHistoryData) ? (
              smsHistoryData.map((historyItem: any, index: any) => {
                return (
                  <IonCard
                    key={index}
                    className={`sms-history-wrapper ${
                      historyItem?.media_data?.[0]?.is_expired === true ? "expired-media" : ""
                    } ${
                      historyItem.request_type === "received" &&
                      "received-sms-wrapper"
                    }
            ${historyItem.request_type === "sent" && "sent-sms-wrapper"}
            `}
                  >
                    {" "}
                    <div className="from-and-to-details">
                      {historyItem.request_type === "received" && (
                        <div className="from-details-name">
                          From:{" "}
                          <span className="from-name">
                            {historyItem.from_user.first_name}{" "}
                            {historyItem.from_user.last_name}
                          </span>{" "}
                        </div>
                      )}
                      <div
                        className={`to-users more-button ${
                          historyItem.request_type === "sent" && "button-width"
                        }`}
                        title="Show Users"
                        id={`more-button-${index}`}
                        onClick={() => {
                          handleMoreButtonClick(index);
                        }}
                      >
                        {
                          <IonIcon
                            slot="end"
                            icon={chevronDownCircle}
                            className="to-users-button"
                          />
                        }
                      </div>
                      <div
                        className={`to-users ${
                          historyItem.request_type === "sent" && "button-width"
                        }`}
                        id={`less-button-${index}`}
                        title="Hide Users"
                        onClick={() => {
                          handleLessButtonClick(index);
                        }}
                      >
                        {
                          <IonIcon
                            slot="end"
                            icon={chevronUpCircle}
                            className="to-users-button"
                          />
                        }
                      </div>
                      <div
                        className="forward-message-icon"
                        id={`${index}`}
                        title="forward message"
                        onClick={() => {
                          props.updateForwardMessage(historyItem);
                        }}
                      >
                        {
                          <IonIcon
                            slot="end"
                            icon={arrowRedoCircleOutline}
                            className="fwd-msg-button"
                          />
                        }
                      </div>
                    </div>
                    <div className="to-details" id={`to-user-details-${index}`}>
                      <div className="to-details-name">
                        To:{" "}
                        <span className="to-name">
                          {!_.isEmpty(historyItem.to_users_list) &&
                            historyItem.to_users_list.map((item: any) => {
                              return <Fragment>{item} </Fragment>;
                            })}
                        </span>{" "}
                      </div>
                    </div>
                    <div className="message-content">
                      {historyItem.message}
                      {historyItem.is_media && (
                        <IonRow>
                          {!_.isEmpty(historyItem.media_data) ? (
                            historyItem.media_data.map((item: any) => {
                              return (
                                <div>
                                  <MediaListCard
                                    selectedPatientId={
                                      historyItem.selectedPatientId
                                    }
                                    selectedUserId={
                                      historyItem.selectedUserGuid
                                    }
                                    mediaItem={item}
                                    selectedDoctorData={
                                      historyItem.selectedDoctorDetails
                                    }
                                    fromHistoryList={true}
                                  ></MediaListCard>
                                </div>
                              );
                            })
                          ) : (
                            <div>
                              <NoResults></NoResults>
                            </div>
                          )}
                        </IonRow>
                      )}
                    </div>
                    <div className="message-date">
                      {utilService.getShortDateWithYear(historyItem.created_on)}
                    </div>
                  </IonCard>
                );
              })
            ) : (
              <div className="no-sms-div">No messages</div>
            )}
          </InfiniteScroll>
        ) : (
          <div className="loader-div">
            <Loader></Loader>
          </div>
        )}
      </IonModal>
    </div>
  );
};

export default MessageHistory;
